import script from "./pedidosPagadosTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./pedidosPagadosTable.vue?vue&type=script&setup=true&lang=ts"

import "./pedidosPagadosTable.vue?vue&type=style&index=0&id=3221e268&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3221e268"]])

export default __exports__